<div mat-dialog-content>
  <p class="center" [anessaTranslation]="instruction"></p>
  <mat-form-field floatLabel="never">
    <input
      matInput
      [placeholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
      [(ngModel)]="data.name"
      (keyup)="onKey($event)">
  </mat-form-field>
</div>
<div mat-dialog-actions style="text-align: center; display: block;">
  <button
    mat-button
    [disabled]="!validName()"
    class="btn-green button-size"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="button-size btn-cancel"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</div>
